import React from "react";

import { Loader } from "./Loader";

export const withLoadingSuspense = <P,>(Component: React.ComponentType<P>) => {
  return (props: P) => {
    return (
      <React.Suspense fallback={<Loader size="lg" spread />}>
        <Component {...props} />
      </React.Suspense>
    );
  };
};
